import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Standard} from '../../../../../models/standard.model';
import {NgForm} from '@angular/forms';
import {Response} from '@angular/http';
import {AdminService} from '../../../../../services/admin.service';

@Component({
  selector: 'app-edit-standard-info',
  templateUrl: './edit-standard-info.component.html',
  styleUrls: ['./edit-standard-info.component.css']
})
export class EditStandardInfoComponent implements OnInit {
  info: any = {};
  standard: any;
  public successInfo = false;
  public errorInfo = false;
  public disableBtn = false;

  translatedLanguage = '';

  constructor(public activeModal: NgbActiveModal,
              private adminService: AdminService) {
  }

  ngOnInit() {
  }

  setStandard(standard: any) {
    this.standard = standard;

    this.info.number = this.standard.number;
    this.info.ruName = this.standard.ruName;
    this.info.ruAnnotation = this.standard.ruAnnotation;


    this.info.enName = this.standard.enName;
    this.info.enAnnotation = this.standard.enAnnotation;

    this.info.translatedMainInfo = this.standard.translatedMainInfo;


    if (this.info.ruName === null || this.info.ruAnnotation === null) {
      this.translatedLanguage = 'EN';
    } else if (this.info.enName === null || this.info.enAnnotation === null) {
      this.translatedLanguage = 'RU';
    } else {
      this.translatedLanguage = 'ALL';
    }

  }

  disableBtnByCharCount() {
    if (this.info.number !== null && this.info.number.length >= 3) {
      if (!this.info.translatedMainInfo || !this.notNullAllFields()) {
        // Valid number; One language
        return this.validOneLanguageFields();
      } else {
        // Two languages
        return this.validAllFields();
      }
    } else {
      // Number is not valid
      return false;
    }
  }

  editInfo() {
    this.successInfo = false;
    this.errorInfo = false;
    this.disableBtn = true;

    if (this.info.translatedMainInfo) {
      if (this.validAllFields()) {
        this.doEditing();
      } else {
        this.successInfo = false;
        this.errorInfo = true;
        this.disableBtn = false;
      }
    } else {
      if (this.validOneLanguageFields()) {
        this.doEditing();
      } else {
        this.successInfo = false;
        this.errorInfo = true;
        this.disableBtn = false;
      }
    }
  }

  private validAllFields() {
    let allValid = true;
    allValid = this.info.number !== null && this.info.number.length >= 3
      && this.info.ruName !== null && this.info.ruName.length >= 3
      && this.info.ruAnnotation !== null && this.info.ruAnnotation.length >= 3
      && this.info.enName !== null && this.info.enName.length >= 3
      && this.info.enAnnotation !== null && this.info.enAnnotation.length >= 3;
    return allValid;
  }

  private validOneLanguageFields() {
    if (this.translatedLanguage === 'RU') {
      // RUSSIAN
      return this.info.ruName !== null && this.info.ruName.length >= 3
        && this.info.ruAnnotation !== null && this.info.ruAnnotation.length >= 3;
    } else if (this.translatedLanguage === 'EN') {
      // ENGLISH
      return this.info.enName !== null && this.info.enName.length >= 3
        && this.info.enAnnotation !== null && this.info.enAnnotation.length >= 3;
    } else {
      return this.validAllFields();
    }
  }

  private doEditing() {
    this.adminService.editStandardInfo(this.standard, this.info).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.standard.number = this.info.number;
          this.standard.enName = this.info.enName;
          this.standard.enAnnotation = this.info.enAnnotation;
          // this.standard.enType = this.info.enType;
          this.standard.ruName = this.info.ruName;
          this.standard.ruAnnotation = this.info.ruAnnotation;
          // this.standard.ruType = this.info.ruType;
          this.successInfo = true;
          this.errorInfo = false;
          this.disableBtn = false;
        }
      },
      (error) => {
        this.errorInfo = true;
        this.successInfo = false;
        this.disableBtn = false;
      }
    );

  }

  private notNullAllFields() {
    return this.info.ruName !== null
      && this.info.ruAnnotation !== null
      && this.info.enName !== null
      && this.info.enAnnotation !== null;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-standard/popups/edit-standard-info/edit-standard-info.component.ts